export enum BIGLogicKind
{
    All = -1,
    Schedulation = 0,
    Logic = 1,
    Alarm = 2,
    AlarmReset = 3,
    PreConditioning = 4,
    PreConditioningEnd = 5,
    KeypadAccess = 6,
    MaintenanceNoticeDelay = 7,
    Custom = 99
}

export enum BIGLogicLogState {
    Inserted = 0,
    ToSolveLater = 1,
    Solved = 2,
    Archived = 3
}

export enum BIGLogicTypeAlarm {
    FireAlarm = 1,
    SupportRequestAlarm = 2,
    AntifreezeAlarm = 3,
    RequestForRoomService = 5,
    RiskOfFlooding = 6, 
    TooHotAlarm = 7,
    TechnicalAlarm = 9
}